import { LoadingState } from 'app/utils/callstate';
import { createReducer, on } from '@ngrx/store';
import { PayrollRuleActions } from '../actions';
import { PayrollRuleState } from '../payroll.types';
import { PayrollRuleEntry } from 'app/api/payroll.rule.api.service';
import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';

// tslint:disable-next-line: no-empty-interface
export const adapter: EntityAdapter<PayrollRuleEntry> = createEntityAdapter<
  PayrollRuleEntry
>({
  selectId: (entry) => entry.key,
});

export const initialPayrollRuleState: PayrollRuleState = adapter.getInitialState(
  {
    companyId: undefined,
    key: undefined,
    filter: undefined,
    callState: LoadingState.Init,
  }
);

export const reducer = createReducer(
  initialPayrollRuleState,
  on(
    PayrollRuleActions.payrollRuleRequested,
    (state, { query }): PayrollRuleState => {
      return {
        ...state,
        companyId: query.companyId,
        key: query.key,
        filter: query.filter,
        callState: LoadingState.Loading,
      };
    }
  ),
  on(PayrollRuleActions.payrollRuleLoaded, (state, { entries }) => {
    return adapter.addAll(entries, {
      ...state,
      callState: LoadingState.Loaded,
    });
  }),
  on(PayrollRuleActions.payrollRuleCreateRequested, (state, _) => {
    return {
      ...state,
      callState: LoadingState.Loading,
    };
  }),
  on(PayrollRuleActions.payrollRuleCreated, (state, { input }) => {
    return adapter.addOne(input, {
      ...state,
      callState: LoadingState.Loaded,
    });
  }),
  on(PayrollRuleActions.payrollRuleRemoveOneRequested, (state, _) => {
    return {
      ...state,
      callState: LoadingState.Loading,
    };
  }),
  on(PayrollRuleActions.payrollRuleRemoved, (state, { input }) => {
    return adapter.removeOne(input.key, {
      ...state,
      callState: LoadingState.Loaded,
    });
  }),
  on(PayrollRuleActions.payrollRuleUpdateOneRequested, (state, _) => {
    return {
      ...state,
      callState: LoadingState.Loading,
    };
  }),
  on(PayrollRuleActions.payrollRuleUpdated, (state, { input }) => {
    return adapter.updateOne(
      { id: input.key, changes: input },
      {
        ...state,
        callState: LoadingState.Loaded,
      }
    );
  }),
  on(PayrollRuleActions.payrollRuleCancelled, (state, { errorMessage }) => {
    return {
      ...state,
      callState: { errorMessage },
    };
  })
);

export const {
  selectAll,
  selectEntities,
  selectIds,
  selectTotal,
} = adapter.getSelectors();
